
import * as akamaiRuntime$GjfIg7BKn1 from '/home/homeyou/shc/build/build-headless/101573/providers/akamai.ts'
import * as ipxRuntime$Gy94xrPvFu from '/home/homeyou/shc/build/build-headless/101573/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "productTileDefault": {
      "modifiers": {
        "width": 335,
        "height": 335
      }
    },
    "productTileLarge": {
      "modifiers": {
        "width": 772,
        "height": 772
      }
    },
    "productTileMedium": {
      "modifiers": {
        "width": 509,
        "height": 509
      }
    },
    "productTileSmall": {
      "modifiers": {
        "width": 246,
        "height": 246
      }
    },
    "singleProductGallery": {
      "modifiers": {
        "width": 920,
        "height": 920
      }
    },
    "thumbsProductGallery": {
      "modifiers": {
        "width": 452,
        "height": 452
      }
    },
    "error": {
      "modifiers": {
        "width": 780,
        "height": 780
      }
    },
    "logo": {
      "modifiers": {
        "width": 104,
        "height": 22
      }
    },
    "error500": {
      "modifiers": {
        "width": 546,
        "height": 94
      }
    },
    "error500Mobile": {
      "modifiers": {
        "width": 246,
        "height": 134
      }
    }
  },
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['akamai']: { provider: akamaiRuntime$GjfIg7BKn1, defaults: {} },
  ['ipx']: { provider: ipxRuntime$Gy94xrPvFu, defaults: {} }
}
        